"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SESSION_KEYS = exports.ICON_TYPE = exports.EXP_TIME_IN_MINUTES = exports.ENV = exports.DEVICE_TYPE = exports.DEFAULT_LABEL = exports.DEFAULT_CONFIG = exports.BREAKPOINTS = exports.AUTH = void 0;

/* eslint-disable max-len */
var ICON_TYPE = 'CloseIcon';
exports.ICON_TYPE = ICON_TYPE;
var DEVICE_TYPE = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  TABLET: 'tablet'
};
exports.DEVICE_TYPE = DEVICE_TYPE;
var DEFAULT_CONFIG = {
  SUB: 'sub',
  SMALL: 'small',
  TITLE_NORMAL: 'titleNormal',
  LINK_COLOR: 'secondary',
  TEXT_COLOR: 'greyDarker',
  ICON_COLOR: 'greyDark',
  LOCALE: 'en-GB',
  CURRENCY: 'MYR',
  ENV: 'staging',
  TOOLTIP: {
    POSITION: 'absolute',
    VIEWPORT: DEVICE_TYPE.DESKTOP,
    LEFT: 'left',
    RIGHT: 'right'
  },
  LOGINMENU: {
    WIDTH: '100%'
  },
  DEVICE: DEVICE_TYPE.DESKTOP,
  ICON: {
    COLOR: {
      PRIMARY: 'primary',
      PRIMARY_DARK: 'primaryDark',
      GREY_DARK: 'greyDark'
    },
    TYPE: 'AccountCircle'
  }
};
exports.DEFAULT_CONFIG = DEFAULT_CONFIG;
var BREAKPOINTS = {
  MOBILE: '599px',
  SMALL_TABLET: '600px',
  MEDIUM_TABLET: '720px',
  LARGE_TABLET: '840px',
  DESKTOP: '1280px'
};
exports.BREAKPOINTS = BREAKPOINTS;
var ENV = {
  development: {
    script: 'https://sso-widget.devairasia.com/bundle.{locale}.js.gz',
    style: 'https://sso-widget.devairasia.com/style.css.gz',
    bigPoints: 'https://k.stg-apiairasia.com/f_bp',
    favoriteMembers: 'https://ssor.stgairasia.com/um/v2/users/{userId}/favorite-members',
    jwtAuth: 'https://flights.devairasia.com/fp/authentication/auth/login',
    creditBalance: 'https://cosmos.devairasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}&customerNumber={customerNumber}',
    creditBalanceV2: 'https://cosmos.devairasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}'
  },
  staging: {
    script: 'https://sso-widget.stgairasia.com/bundle.{locale}.js.gz',
    style: 'https://sso-widget.stgairasia.com/style.css.gz',
    bigPoints: 'https://k.stg-apiairasia.com/f_bp',
    favoriteMembers: 'https://ssor.stgairasia.com/um/v2/users/{userId}/favorite-members',
    jwtAuth: 'https://flights.stgairasia.com/fp/authentication/auth/login',
    creditBalance: 'https://cosmos.stgairasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}&customerNumber={customerNumber}',
    creditBalanceV2: 'https://cosmos.stgairasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}'
  },
  production: {
    script: 'https://sso-widget.airasia.com/bundle.{locale}.js.gz',
    style: 'https://sso-widget.airasia.com/style.css.gz',
    bigPoints: 'https://k.apiairasia.com/f_bp',
    favoriteMembers: 'https://ssor.airasia.com/um/v2/users/{userId}/favorite-members',
    jwtAuth: 'https://flights.airasia.com/fp/authentication/auth/login',
    creditBalance: 'https://cosmos.airasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}&customerNumber={customerNumber}',
    creditBalanceV2: 'https://cosmos.airasia.com/uhf/api/v1/credit?accountHolderType=Default&currencyCode={currency}'
  }
};
exports.ENV = ENV;
var AUTH = {
  development: {
    username: 'hercules',
    password: 'nQHzx29j7BTYkA5P'
  },
  staging: {
    username: 'hercules',
    password: 'nQHzx29j7BTYkA5P'
  },
  production: {
    username: 'hercules',
    password: 'sD9KEktx5BLqAzWU'
  }
};
exports.AUTH = AUTH;
var DEFAULT_LABEL = 'Login/Signup';
exports.DEFAULT_LABEL = DEFAULT_LABEL;
var EXP_TIME_IN_MINUTES = '9';
exports.EXP_TIME_IN_MINUTES = EXP_TIME_IN_MINUTES;
var SESSION_KEYS = {
  USERDATA: 'userData',
  ISLOGGEDIN: 'isLoggedIn',
  USERCONFIGTOKENS: 'userConfigTokens',
  RESPONSE: 'response',
  CONFIG: 'userConfig',
  TOKENS: 'tokens',
  GETCONFIG: 'config',
  GETTOKENS: 'getTokens',
  GETUSER: 'getUser'
};
exports.SESSION_KEYS = SESSION_KEYS;